$(document).on("change", "#ppic-planning-filter-date, #ppic-planning-filter-type", function(){
  __planning_refresh()
})

$(document).on("click", ".planning-machine-card", function(){
  const code = $(this).find(".machine-number").text()
  const date = $('#ppic-planning-filter-date').val()
  const record_id = $(this).attr("record_id")

  showModal(`Planning Mesin ${code} | ${date}`)

  $.ajax({
    url: window.location.href + "/" + record_id,
    data: { date: date },
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }
  })
})

$(document).on("click", "#ppic-planning-new-planning", function(){
  $(this).attr("disabled", "disabled")

  const table = $("#ppic-planning-detail-table")

  if (table.find("tbody tr").length == 1 && !table.find("tbody tr").attr("record_id")) {
    table.find("tbody").html("")
  }

  const current_length = table.find("tbody tr").length

  table.find("tbody").append(`
    <tr record_id='_blank'>
      <td class="py-1">${current_length + 1}</td>
      <td class="py-1" product><select class='form-select form-select-sm product_id py-0'>${$("#ppic-planning-product-option").html()}</select></td>
      <td class="py-1 text-end" qty><input type="number" min="0" class="form-control form-control-sm qty text-end"></td>
      <td class="py-1" action><button type="button" class="btn btn-primary btn-sm ppic-planning-save-new-planning">Simpan</button></td>
    </tr>
  `)
})

$(document).on("click", ".ppic-planning-save-new-planning", function(){
  const $this = $(this)
  const $tr = $this.closest("tr")

  const table = $("#ppic-planning-detail-table")
  const machine_id = table.attr("mid")
  const date = table.attr("dt")
  const product_id = $this.closest("tr").find(".product_id").val()
  const qty = $this.closest("tr").find(".qty").val()

  if (!product_id){
    alert("Gagal simpan: Produk belum dipilih!")
    return false
  }

  if (!qty){
    alert("Gagal simpan: Qty tidak valid!")
    return false
  }

  if (qty <= 0) {
    alert("Gagal simpan: Qty tidak boleh kurang atau sama dengan nol!")
    return false
  }

  $.ajax({
    url: window.location.href,
    method: "POST",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    data: {
      machine_id: machine_id,
      date: date,
      product_id: product_id,
      qty: qty
    },
    dataType: "JSON",
    beforeSend: function(){
      $this.attr("disabled", "disabled")
    },
    success: function(res) {
      $("#ppic-planning-new-planning").removeAttr("disabled")
      $tr.attr("record_id", res.data.id)
      $tr.find("td[product]").html(res.data.product)
      $tr.find("td[qty]").html(res.data.qty)
      $tr.find("td[action]").html(__planning_button_main())
      __planning_refresh()
    },
    error: function(jqXHR) {
      $this.removeAttr("disabled")
      alert(jqXHR.responseJSON.message)
    }
  })
})

$(document).on("click", ".ppic-planning-edit-planning", function(){
  const $action = $(this).closest("tr").find("td[action]")
  const $qty = $(this).closest("tr").find("td[qty]")
  const current_qty = $qty.text()

  $qty.html(`<input type="number" class="form-control form-control-sm qty text-end" value="${current_qty}">`)
  $action.html(__planning_button_edit())
})

$(document).on("click", ".ppic-planning-cancel-edit-planning", function(){
  const $action = $(this).closest("tr").find("td[action]")
  const $qty = $(this).closest("tr").find("td[qty]")
  const current_qty = $qty.attr("qty")

  $qty.text(current_qty)
  $action.html(__planning_button_main())
})

$(document).on("click", ".ppic-planning-save-edit-planning", function(){
  const $this = $(this)
  const $tr = $this.closest("tr")
  const record_id = $tr.attr("record_id")
  const qty = $tr.find(".qty").val()

  $.ajax({
    url: window.location.href + "/" + record_id,
    method: "PATCH",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    data: { qty: qty },
    dataType: "JSON",
    beforeSend: function(){
      $this.attr("disabled", "disabled")
    },
    success: function(res) {
      $this.closest('tr').find("td[qty]").html(res.data.qty)
      $this.closest('tr').find("td[action]").html(__planning_button_main())
    },
    error: function(jqXHR) {
      $this.removeAttr("disabled")
      alert(jqXHR.responseJSON.message)
    }
  })
})

$(document).on("click", ".ppic-planning-delete-planning", function(){
  const $this = $(this)
  const $tr = $(this).closest("tr")
  const record_id = $tr.attr("record_id")

  $.ajax({
    url: window.location.href + "/" + record_id,
    method: "DELETE",
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
    dataType: "JSON",
    beforeSend: function(){
      $this.attr("disabled", "disabled")
    },
    success: function(res) {
      $tr.remove()
      __planning_refresh()
    },
    error: function(jqXHR) {
      $this.removeAttr("disabled")
      alert(jqXHR.responseJSON.message)
    }
  })
})

function __planning_refresh(){
  const date = $("#ppic-planning-filter-date")
  const type = $("#ppic-planning-filter-type")

  if (!date.val()){
    return false
  }

  $.ajax({
    url: window.location.href + "/filter",
    data: {
      date: date.val(),
      type: type.val()
    },
    beforeSend: function(){
      $('.card-body').html(setSpinner())
    },
    success: function(res){
      $('.card-body').html(res)
    }
  })
}

function __planning_button_main(){
  return `
    <button type="button" class="btn btn-warning btn-sm ppic-planning-edit-planning">Edit</button>
    <button type="button" class="btn btn-danger btn-sm ppic-planning-delete-planning">Hapus</button>
  `
}

function __planning_button_edit(){
  return `
    <button type="button" class="btn btn-secondary btn-sm ppic-planning-cancel-edit-planning">Batal</button>
    <button type="button" class="btn btn-primary btn-sm ppic-planning-save-edit-planning">Simpan</button>
  `
}